import { faker } from '@faker-js/faker'

import { getPrice } from './Price'

import { ServiceOfferListView, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getServiceOfferListView = asBuilder((): ServiceOfferListView => {
  return {
    id: faker.number.int(),
    available: faker.datatype.boolean(),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    title: faker.string.uuid(),
    paymentEnabled: faker.datatype.boolean(),
    surgicalRewardExist: faker.datatype.boolean(),
    period: {
      startsAt: new Date().toISOString(),
      endsAt: new Date().toISOString(),
      started: faker.datatype.boolean(),
      inPeriod: faker.datatype.boolean(),
    },
    treatmentCategories: faker.helpers.multiple(() => ({
      treatmentCategoryId: faker.number.int(),
      name: faker.string.uuid(),
    })),
    onGuaranteedAd: faker.datatype.boolean(),
    price: {
      ...getPrice(),
      specialOffer: faker.datatype.boolean(),
    },
    rating: {
      totalRating: faker.number.float({ min: 0, max: 10, multipleOf: 0.1 }),
      ratingCount: faker.number.int(),
    },
    consultationCount: faker.number.int(),
    thumbnail: { url: faker.image.url() },
    includeVat: faker.datatype.boolean(),
    hasDraft: faker.datatype.boolean(),
  }
})
